import * as PropTypes from 'prop-types'
import classNames from 'classnames'

export const TextsPropTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isCentered: PropTypes.bool,
  isInline: PropTypes.bool,
  isItalic: PropTypes.bool,
  isLight: PropTypes.bool,
  isTight: PropTypes.bool
}

class Text extends React.PureComponent {
  render () {
    const {
      children,
      className,
      isCentered,
      isInline,
      isItalic,
      isLight,
      isTight,
      type,
      ...restProps
    } = this.props

    const Tag = isInline ? 'span' : 'p'

    return (
      <Tag
        className={classNames(
          {
            [className]: className,
            [`Text--${type}`]: type,
            'Text--centered': isCentered,
            'Text--italic': isItalic,
            'Text--light': isLight,
            'Text--tight': isTight,
          }
        )}
        {...restProps}
      >
        {children}
      </Tag>
    )
  }
}

export class TextNavTitle extends React.PureComponent {
  static propTypes = TextsPropTypes

  render () {
    return (
      <Text {...this.props} type='navTitle' />
    )
  }
}

export class TextCopy extends React.PureComponent {
  static propTypes = TextsPropTypes

  render () {
    return (
      <Text {...this.props} type='copy' />
    )
  }
}
